import { panels } from './ui-panel-registry.js';

let panelStack = [];

export function openPanel(name) {
  console.log(`[UI-Panel-Controller] Opening panel: ${name}`);
  const current = panelStack[panelStack.length - 1];
  // if (current) closePanel(current, false); // don’t clear stack

  const panel = panels[name];
  console.log(`[UI-Panel-Controller] Get panel element: ${panel?.id || name}`);
  if (panel) {
    console.log(`[UI-Panel-Controller] panel exists: ${panel.id}, make it visible`);
    // panel.classList.add('fullscreen-sheet');
    panel.classList.remove('hidden');
    requestAnimationFrame(() => {
      panel.classList.add('visible');
    });
    panelStack.push(name);
  }
}

export function closePanel(name = panelStack.pop(), shouldPop = true) {
  console.log(`[UI-Panel-Controller] Closing panel: ${name}`);
  const panel = panels[name];
  if (panel) {
    panel.classList.remove('visible');
    panel.classList.add('exiting');

    setTimeout(() => {
      panel.classList.remove('exiting');
      panel.classList.add('hidden');
    }, 400); // Match this to your transition duration
    if (shouldPop) panelStack.pop();
  }

  // Reopen previous if it exists
  const previous = panelStack[panelStack.length - 1];
  if (previous) {
    panels[previous].classList.remove('hidden');
    // panels[previous].classList.add('visible', 'fullscreen-sheet');
    panels[previous].classList.add('visible');
  }
}